import {
	Card,
	CardHeader,
	CardContent,
	Divider,
	Table,
	TableBody,
	TableRow,
	TableCell,
} from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { useStyles } from './style';

interface TermInformationProps {
	className?: string;
	termData: object;
}

const TermInformation = (props: TermInformationProps) => {
	const { termData, className } = props;
	const { t } = useTranslation();

	const classes = useStyles();

	return (
		<Card className={clsx(classes.root, className)}>
			<CardHeader title={t('views.termDetails.termInformation.header')} />
			<Divider />
			<CardContent>
				<Table>
					<TableBody>
						<TableRow>
							<TableCell>{t('ui.title')}</TableCell>
							<TableCell>{termData.title}</TableCell>
						</TableRow>
						<TableRow className={classes.tableRow}>
							<TableCell style={{ verticalAlign: 'top' }}>{t('ui.organisation')}</TableCell>
							<TableCell className={classes.editorContainer}>
								{termData.organisationReference.name}
							</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</CardContent>
		</Card>
	);
};

export default TermInformation;
